import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLayers from 'vuelayers'
import 'v-markdown-editor/dist/v-markdown-editor.css'
import Editor from 'v-markdown-editor'
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(VueLayers)
Vue.use(Editor);

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, err => Promise.reject(err));

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
